var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "printpologs"
  }, [_c('b-card', [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "card-header -filter_main"
  }, [_c('label', [_vm._v("Cargo Print PO Log Summary")])])])]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-body1"
  }, [_c('div', {
    staticClass: "form group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Enter AWB")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-shopping-cart'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.POAwb),
      expression: "POAwb"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true,
    },
    attrs: {
      "type": "text",
      "name": "POAwb",
      "id": "POAwb",
      "placeholder": "Please enter AWB No."
    },
    domProps: {
      "value": (_vm.POAwb)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.POAwb = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("From Date ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-calendar-o'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.PrintAWBFromDate),
      expression: "PrintAWBFromDate"
    }],
    staticClass: "form-control",
    class: {
      'error': _vm.errors.has('PrintAWBFromDate')
    },
    attrs: {
      "type": "date",
      "lang": "en",
      "name": "PrintAWBFromDate",
      "onkeydown": "return false",
      "not-before": _vm.validDateRangeFrom1,
      "max": _vm.todaysDate1,
      "not-after": _vm.PrintAWBToDate ? _vm.PrintAWBToDate : _vm.todaysDate1
    },
    domProps: {
      "value": (_vm.PrintAWBFromDate)
    },
    on: {
      "change": _vm.checkEndDate,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.PrintAWBFromDate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.FromDateErr))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("To Date ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-o'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.PrintAWBToDate),
      expression: "PrintAWBToDate"
    }],
    staticClass: "form-control",
    class: {
      'error': _vm.errors.has('PrintAWBToDate')
    },
    attrs: {
      "lang": "en",
      "type": "date",
      "min": _vm.selectedStartDate,
      "disabled": _vm.PrintAWBFromDate == null,
      "name": "PrintAWBToDate",
      "not-before": _vm.PrintAWBFromDate,
      "not-after": _vm.validDateRange1,
      "max": _vm.validDateRange1
    },
    domProps: {
      "value": (_vm.PrintAWBToDate)
    },
    on: {
      "change": _vm.checkStartDate,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.PrintAWBToDate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.ToDateErr))])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button",
      "title": "Search"
    },
    on: {
      "click": _vm.poSearchFilter
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Show Print PO Log")]), _vm._v(" "), _c('button', {
    staticClass: "-btn btn-danger",
    attrs: {
      "type": "reset",
      "title": "Reset"
    },
    on: {
      "click": _vm.resetPOSearch
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Reset")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h4', {
    staticClass: "header",
    staticStyle: {
      "padding-top": "5px"
    }
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Print PO Report")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b', {
    staticStyle: {
      "float": "right",
      "padding-top": "5px",
      "color": "black"
    }
  }, [_vm._v("Total Records: " + _vm._s(_vm.totalAwbCount))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "8rem"
    }
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.exportPOData
    }
  }, [_vm._v("Export Data")])])]), _vm._v(" "), _c('table', {
    staticClass: "styled-table",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Parent AWB")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("MPS Count")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Source")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("User id")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("User Email")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Origin Hub")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Print Date")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.TotalAwbData), function(data, index) {
    return (_vm.totalAwbCount > 0) ? _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.offset + index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.awb))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.mpscount))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.sourceType))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.userid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.useremail))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.hubName))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.createddate))])]) : _vm._e()
  }), _vm._v(" "), (_vm.totalAwbCount == 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "16"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)]), _vm._v(" "), _c('p'), _vm._v(" "), _c('pagination', {
    attrs: {
      "total-pages": _vm.totalAwbPage,
      "total": _vm.totalAwbCount,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentAwbPage
    },
    on: {
      "pagechanged": _vm.onPagePOChange
    }
  })], 1)], 1)], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b200f5d","hasScoped":true}!./src/modules/report/views/PrintingLog/printpologs/printpologs.component.html
// module id = 2095
// module chunks = 3